import { useApolloClient } from '@apollo/client';
import { useCallback, useEffect } from 'react';
export var useRefetchQueries = function useRefetchQueries(_ref) {
  var queriesToFetch = _ref.queriesToFetch,
      skip = _ref.skip;
  var client = useApolloClient();
  var refetch = useCallback(function () {
    void client.refetchQueries({
      include: queriesToFetch
    });
  }, [client, queriesToFetch]);
  useEffect(function () {
    if (!skip) refetch();
  }, [skip, refetch]);
};